import { MenuPositionX, MenuPositionY } from '@angular/material/menu';

import { SnMenuItemConfig } from './menu-item-config.type';

interface ISnMenuConfig<D> {
  items: SnMenuItemConfig<D>[];
  positionX?: MenuPositionX;
  positionY?: MenuPositionY;
}

export type SnMenuConfig<D = any> = ISnMenuConfig<D> | SnMenuItemConfig<D>[];
